import React, { useEffect, useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { getImages } from '../../Const';

const PdfDownloader = ({ pdfRef, targetRef, values, page2Ref }) => {
    const [formattedLocationValue, setFormattedLocationValue] = useState("");
    const [formattedPromoBannerValue, setFormattedPromoBannerValue] = useState("");

    // Function to format the address
    // const formatAddress = (address) => {
    //     if (address.includes(",") && address.split(",").length >= 2) {
    //         const parts = address.split(",");

    //         const streetAndCity = parts[0].trim();
    //         const stateZip = parts[1].trim();

    //         const [state, zip] = stateZip.split(" ");

    //         const streetParts = streetAndCity.split(" ");

    //         const cityWordsCount = 2;
    //         const city = streetParts.slice(-cityWordsCount).join(" ");
    //         const street = streetParts.slice(0, -cityWordsCount).join(" ");

    //         return `${street}<br/>${city}, ${state} ${zip}`;
    //     }
    //     return address;
    // };

    // useEffect(() => {
    //     // const formattedPromoBanner = formatAddress(values.promoBanner.value);
    //     // const formattedLocation = formatAddress(values.locations.value);

    //     setFormattedPromoBannerValue(formattedPromoBanner);
    //     // setFormattedLocationValue(formattedLocation);
    // }, [values?.promoBanner.value]); // Trigger effect if either address changes
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = String(today.getFullYear()).slice(-2);

    const mileage = values.mileage.value;
    const mileageStr = String(mileage).padStart(6, '0');
    const digits = mileageStr.split('');
    return (
        <>
            {/* {console.log("values", values)} */}
            <div ref={pdfRef} >
                {/* Page 1 */}
                <div
                    className='ap-letter-box'
                    style={{
                        padding: "50px 30px",
                        backgroundColor: "#fff",
                        fontFamily: "Roboto, Arial",
                        pageBreakAfter: 'always'

                    }}
                >
                    <div
                        style={{
                            fontSize: '18px',
                            color: '#000',
                            textTransform: 'uppercase',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}
                    >Dupont Registry</div>
                    <div
                        style={{
                            fontSize: '14px',
                            color: '#000',
                            textTransform: 'uppercase',
                            textAlign: 'center',
                            fontWeight: 'bold'
                        }}
                    >Bill Of Sale</div>
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-between",
                            fontWeight: 'bold'
                        }}
                    >
                        <div
                            style={{
                                fontSize: '14px',
                                color: '#000',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontWeight: 'bold'
                            }}
                        >This Is Not An Invoice</div>
                        <div
                            style={{
                                fontSize: '14px',
                                color: '#000',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontWeight: 'bold'
                            }}
                        >Document Not Valid For Export</div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}
                    >
                        <div
                            style={{
                                width: '35%',
                            }}
                        >
                            <div style={{
                                border: 'solid 1px #000',
                                padding: '4px'
                            }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        minHeight: '100px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '65%',
                                            padding: '4px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: '14px',
                                                color: '#000',
                                                fontWeight: 'bold',
                                                marginBottom: '3px'
                                            }}
                                        >duPoint Registry</div>
                                        <div
                                            style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: '400'
                                            }}
                                        >5972 Ne 4th Avenue Miami, FL 33137</div>
                                    </div>
                                    <div
                                        style={{
                                            width: '35%',
                                            padding: '4px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: '13px',
                                                color: '#000',
                                                fontWeight: 'bold',
                                                marginBottom: '3px'
                                            }}
                                        >Sale Date</div>
                                        <div
                                            style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: '400'
                                            }}
                                        >{values.date.value}</div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        minHeight: '100px'
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            color: '#000',
                                            fontWeight: 'bold',
                                            marginBottom: '3px'
                                        }}
                                    >Pickup Location</div>
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '400'
                                        }}
                                    >&nbsp;</div>
                                </div>
                                <div
                                    style={{
                                        minHeight: '100px'
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            color: '#000',
                                            fontWeight: 'bold',
                                            marginBottom: '3px'
                                        }}
                                    >Vehicle Information</div>
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '400',
                                            lineHeight: '22px',
                                            marginBottom: '15px'
                                        }}
                                    >
                                        {values.year.value} {values.make.value} {values.model.value} <br />
                                        {values.trim.value} {values.color.value} <br />
                                        {values.vin.value}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '500',
                                            lineHeight: '22px',
                                            marginBottom: '15px'
                                        }}
                                    >
                                        Mileage: {Number(values.mileage.value).toLocaleString('en-US')} miles
                                    </div>
                                    <div
                                        style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '500',
                                            lineHeight: '22px',
                                            marginBottom: '15px'
                                        }}
                                    >
                                        License Plate No:
                                    </div>
                                </div>
                                <div>
                                    <div
                                        style={{
                                            fontSize: '14px',
                                            color: '#000',
                                            fontWeight: 'bold',
                                            marginBottom: '3px'
                                        }}
                                    >Title Information</div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: '400',
                                                lineHeight: '22px',
                                            }}
                                        >
                                            State: &nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div
                                            style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: '400',
                                                lineHeight: '22px',
                                            }}
                                        >
                                            Number
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                border: 'solid 1px #000',
                                padding: '4px',
                                borderTop: 'none',
                                minHeight: '100px'
                            }}>
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        marginBottom: '3px'
                                    }}
                                >Vehicle Features</div>
                            </div>
                        </div>
                        <div
                            style={{
                                width: '65%',
                                border: 'solid 1px #000',
                                padding: '0',
                                borderLeft: 'none'
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '14px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    marginBottom: '3px',
                                    textAlign: 'center',
                                    padding: '5px',
                                }}
                            >Vehicle Purchase Price</div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0 10px'
                                }}
                            >
                                <div style={{
                                    fontSize: '13px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                }}>
                                    Sale Price
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: '400',
                                    padding: '5px 0 5px 25px',
                                }}>$ {Number(values.price.value).toLocaleString('en-US')}</div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0 10px'
                                }}
                            >
                                <div style={{
                                    fontSize: '13px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                }}>
                                    Adjustments
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: '400',
                                    padding: '5px 0 5px 25px',
                                }}>$ {Number(values.adjustments.value).toLocaleString('en-US')}</div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0 10px'
                                }}
                            >
                                <div style={{
                                    fontSize: '13px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                }}>
                                    Final Sale Price
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: '400',
                                    padding: '5px 0 5px 25px',
                                    borderTop: 'solid 2px #000'
                                }}>$ {Number(values.price.value - values.adjustments.value).toLocaleString('en-US')}</div>
                            </div>


                            {/* Seller and Buyer */}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0',
                                    borderTop: 'solid 1px #000'
                                }}
                            >
                                <div
                                    style={{
                                        width: '50%',
                                        padding: '5px 10px',
                                        height: '100%'
                                    }}
                                >
                                    <div style={{
                                        minHeight: '100px',
                                    }}>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#000',
                                            fontWeight: 'bold',
                                        }}>
                                            Seller
                                        </div>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '400',
                                            lineHeight: '22px'
                                        }}>
                                            {values.seller_name.value} <br />
                                            {values.seller_address.value}
                                        </div>
                                    </div>
                                    <div style={{
                                        minHeight: '60px'
                                    }}
                                    >
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '500',
                                            lineHeight: '22px'
                                        }}>
                                            Seller Rep:
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: '50%',
                                        padding: '5px 10px',
                                        borderLeft: 'solid 1px #000',
                                        height: '100%'
                                    }}
                                >
                                    <div style={{
                                        minHeight: '100px',
                                    }}>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#000',
                                            fontWeight: 'bold',
                                        }}>
                                            Buyer
                                        </div>
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '400',
                                            lineHeight: '22px'
                                        }}>
                                            duPont Registry <br />
                                            5972 NE 4th Avenue Miami,
                                            FL 33137
                                        </div>
                                    </div>
                                    <div style={{
                                        minHeight: '60px'
                                    }}
                                    >
                                        <div style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: '500',
                                            lineHeight: '22px'
                                        }}>
                                            Buyer Rep:<br/><span className="pdf-signature">{values.buyer_name.value}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Text Info */}
                            <div
                                style={{
                                    width: '100%',
                                    padding: '5px 10px',
                                    borderTop: 'solid 1px #000',
                                }}
                            >
                                <div style={{
                                    fontSize: '13px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                }}>
                                    Odometer Disclosure
                                </div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: '400',
                                    marginBottom: '15px'
                                }}>Federal law (and state law, if applicable) requires the Seller to state the mileage upon transfer of ownership. Providing false information may restult in fines and/or imprisonment.</div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#333',
                                    fontWeight: '400',
                                }}>Seller hereby states that the odometer for this Vehicle now reads identically to the Mileage stated on this Bill of Sale under Vehicle information and certifies to the best of Seller's knowledge that this reflects the actual mileage of the Vehicle, unless disclosed otherwise in the Announcements & Notes Below.</div>
                                <div style={{
                                    fontSize: '13px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    marginTop: '15px'
                                }}>
                                    Announcements & Notes
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Text Info */}
                    <div
                        style={{
                            width: '100%',
                            padding: '5px 5px',
                        }}
                    >
                        <div style={{
                            fontSize: '13px',
                            color: '#333',
                            fontWeight: '400',
                        }}>Seller agrees to sell the vehicle covered by this Bill of Sale to Buyer for the price noted herein.<br />
                            Seller is the transferor of the vehicle and is responsible for all disclosures, including odometer and mileage.<br />
                            Buyer must return a signed copy of the title front and back, including the odometer statement therein, to Seller or be subject to civil and criminal penalties. See 48 CFR #580.5(f).<br />
                            duPont Registry retains a purchase money security interest in the Vehicle and its title until good funds are received from the buyer.<br />
                            Seller and buyer agree to the duPont Registry Terms and Conditions in effect at the time of the sale.<br />
                            Sale terms and this Bill of Sale are subject to adjustments by duPont Registry. Please check your customer account for most current version of this document. Bill of Sale is not an invoice. Please refer to Invoices in your account.<br />
                            The Carfax Report and Manheim Inspection Report are not the product of the Seller and are not to be interpreted as being the Seller's representations. The vehicle is being sold "AS-IS" without any warranty (except for any applicable manufacturer's warranty which may apply) or representations as to past accident or damage history.<br />
                            The Seller is not responsible for and Purchaser shall hold harmless and indemnify Seller (including reasonable defense fees and costs) with respect to any warranty or representation Purchaser may make regarding the condition or history of the vehicle to any third party buyer.
                        </div>
                    </div>
                </div>
                <br />
                <br />
                {/* Page 2 */}
                <div
                    style={{
                        padding: "20px 30px",
                        backgroundColor: "#fff",
                        fontFamily: "Roboto, Arial",
                        lineHeight: 'normal'

                    }}
                    ref={page2Ref}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <div
                            style={{
                                textAlign: 'left',
                                fontSize: '10px',
                                width: '25%'
                            }}
                        >HSMV 82995 (REV. 06/21</div>
                        <div
                            style={{
                                textAlign: 'center',
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}
                        >
                            STATE OF FLORIDA <br />
                            DEPARTMENT OF HIGHWAY SAFETY AND MOTOR VEHICLES <br />
                            DIVISION OF MOTOR SERVICES
                        </div>
                        <div
                            style={{
                                textAlign: 'right',
                                fontSize: '10px',
                                width: '25%'
                            }}
                        >(Instructions on Reverse Side)</div>
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            fontFamily: 'Times New Roman',
                            fontSize: '11px'
                        }}
                    >2900 Apalachee Parkway - Tallahassee, 32399-0610</div>
                    <div
                        style={{
                            textAlign: 'center',
                            fontFamily: 'Times New Roman',
                            fontSize: '12px',
                            marginTop: '3px',
                            fontWeight: 'bold'
                        }}
                    >MOTOR VEHICLE POWER OF ATTORNEY/ODOMETER DISCLOSURE</div>
                    <div
                        style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            marginTop: '3px',
                            padding: '3px 0',
                            borderTop: 'solid 1px #000',
                            borderBottom: 'solid 1px #000'
                        }}
                    >This form may be used when title is physically held by lienholder or when the title has been lost. This form must be submitted to the state by the person exercising
                        Powers of Attorney. Failure to do so may result in fines or imprisonment.</div>
                    <div
                        style={{
                            textAlign: 'center',
                            fontFamily: 'Times New Roman',
                            fontSize: '12px',
                            fontWeight: 'bold'
                        }}
                    >VEHICLE DESCRIPTION</div>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderTop: 'solid 1px #000',
                            borderBottom: 'solid 1px #000'
                        }}
                    >
                        <div
                            style={{
                                width: '25%',
                                textAlign: 'center'
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Vehicle Identification Number</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                            }}>{values.vin.value}</div>
                        </div>
                        <div
                            style={{
                                width: '15%',
                                textAlign: 'center',
                                borderLeft: 'solid 1px #000',
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Year</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                whiteSpace: 'nowrap'
                            }}>{values.year?.value}</div>
                        </div>
                        <div
                            style={{
                                width: '15%',
                                textAlign: 'center',
                                borderLeft: 'solid 1px #000',
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Make</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                whiteSpace: 'nowrap',
                            }}>{values.make.value}</div>
                        </div>
                        <div
                            style={{
                                width: '15%',
                                textAlign: 'center',
                                borderLeft: 'solid 1px #000',
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Model</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                whiteSpace: 'nowrap',
                            }}>{values.model.value}</div>
                        </div>
                        <div
                            style={{
                                width: '15%',
                                textAlign: 'center',
                                borderLeft: 'solid 1px #000',
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Body</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                            }}>&nbsp;</div>
                        </div>
                        <div
                            style={{
                                width: '15%',
                                textAlign: 'center',
                                borderLeft: 'solid 1px #000',
                            }}
                        >
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '13px',
                            }}>Title No.</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                            }}>&nbsp;</div>
                        </div>
                    </div>
                    {/* Part A */}
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '11px',
                        fontWeight: 'bold'
                    }}>PART A. TRANSFEROR (SELLER'S) POWER OF ATTORNEY TO DISCLOSE MILEAGE.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'end',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '8px'
                        }}>I/We,&nbsp;&nbsp;</div>
                        <div style={{
                            width: '46%'
                        }}>
                            <div style={{
                                fontFamily: 'arial',
                                fontSize: '12px',
                                fontWeight: '600',
                                borderBottom: 'solid 1px #000',
                                textAlign: 'left',
                                paddingLeft: '7px',
                                color: '#333'
                            }}>{values.seller_name.value}</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Print Seller's Name)
                            </div>
                        </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '8px',
                        }}>&nbsp;&nbsp;appoint&nbsp;&nbsp;</div>
                        <div style={{
                            width: '46%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Print Name of Dealership/Business)
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'end'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '15px'
                        }}>as of&nbsp;&nbsp;</div>
                        <div style={{
                            width: '27%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Date)
                            </div>
                        </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '15px',
                        }}>&nbsp;&nbsp;as my/our attorney-in-fact with full authority to transfer title, to satisfy any lien and to disclose</div>
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '13px',
                    }}>the mileage for the vehicle described above, exactly as stated in the following disclosure.</div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '13px',
                        margin: '3px 0'
                    }}><strong>WARNING:</strong> Federal law and State law require that you state the mileage in connection with transfer of ownership. Providing a false stat ement may result in
                        fines or imprisonment.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                        }}>I/WE STATE THAT THIS</div>
                        <div style={{
                            width: '12px',
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0 5px 2px'
                        }}></div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                        }}>5DIGIT OR</div>
                        <div style={{
                            width: '12px',
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0 5px 2px'
                        }}></div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            marginRight: '12px'
                        }}>6 DIGIT ODOMETER NOW READS</div>
                        {digits.map((digit, index) => (
                            <React.Fragment key={index}>
                                <div  style={{
                                    width: '12px',
                                    minWidth: '12px',
                                    height: '12px',
                                    border: 'solid 1px #000',
                                    margin: '0 2px 2px',
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    lineHeight: '11px'
                                }}>
                                    {digit}
                                </div>
                                {index === 2 && ','}
                            </React.Fragment>
                        ))}
                        <div style={{
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0px 0px 3px 10px',
                            fontFamily: 'Times New Roman',
                            fontSize: '8px',
                            padding: '0 1px'
                        }}>XX</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '8px',
                            marginRight: '12px',
                            marginLeft: '5px'
                        }}>(NO TENTHS) MILES,</div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                        }}>DATE READ</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{day[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{day[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            marginBottom: '-5px'
                        }}>/</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{month[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{month[1]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            marginBottom: '-5px'
                        }}>/</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{year[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{year[1]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                            textTransform: 'uppercase'
                        }}>, AND I/WE HEREBY CERTIFY THAT TO THE BEST OF MY/OUR Knowledge the Odometer Reading:</div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '10px 0'
                        }}
                    >
                        <div style={{
                            width: '33.33%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>1. REFLECTS ACTUAL MILAGE</div>
                        </div>
                        <div style={{
                            width: '33.33%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>2.IS IN EXCESS OF ITS MECHANICAL LIMITS.</div>
                        </div>
                        <div style={{
                            width: '33.33%',
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'start'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>3. IS NOT THE ACTUAL MILEAGE <br />
                                WARNING ODOMETER DISCREPANCY</div>
                        </div>
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>UNDER PENALTY OF PERJURY, I DECLARE THAT I HAVE READ THE FOREGOING DOCUMENT AND THAT THE FACTS STATED IN IT ARE TRUE.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '0 0',
                            flexWrap: 'wrap'
                        }}
                    >
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Seller's Signature
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '75%'
                                }}
                                ref={targetRef}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Seller's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;{values.seller_name.value}</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Co Seller's Signatur
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '72%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Co Seller's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '67%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Seller's Street Address
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '25%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '85%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    State
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Zip
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Purchaser's Signature
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '72%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Purchaser's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    borderBottom: 'solid 1px #000',
                                    width: '67%',
                                }}>{values.buyer_name.value}, AGENT</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    paddingBottom: '8px',
                                }}>
                                    Purchaser's Dealership Name
                                </div>

                                <div style={{
                                    width: '62%'
                                }}>
                                    <div style={{
                                        fontFamily: 'arial',
                                        fontSize: '12px',
                                        textAlign: 'left',
                                        paddingLeft: '7px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        textTransform: 'uppercase',
                                        borderBottom: 'solid 1px #000',
                                    }}>Dupont Registry</div>
                                    <div style={{
                                        fontFamily: 'Times New Roman',
                                        fontSize: '9px',
                                        textAlign: 'center'
                                    }}>
                                        (Print Name of Dealership/Business)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    paddingBottom: '0',
                                }}>
                                    Dealer License No
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textTransform: 'uppercase',
                                    borderBottom: 'solid 1px #000',
                                    width: '78%'
                                }}>V1/1147932/1</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Business Address
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textTransform: 'uppercase',
                                    borderBottom: 'solid 1px #000',
                                    width: '76%'
                                }}>5972 NE 4TH AVE</div>
                            </div>
                        </div>
                        <div style={{
                            width: '25%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textTransform: 'uppercase',
                                    borderBottom: 'solid 1px #000',
                                    width: '85%'
                                }}>MIAMI</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    State
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textTransform: 'uppercase',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>ML</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '2px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Zip
                                </div>
                                <div style={{
                                    fontFamily: 'arial',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingLeft: '7px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textTransform: 'uppercase',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>33137</div>
                            </div>
                        </div>
                    </div>
                    {/* Part B */}
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '11px',
                        fontWeight: 'bold'
                    }}>PART B. TRANSFEREE (PURCHASER) POWER OF ATTORNEY TO REVIEW TITLE DOCUMENTS AND ACKNOWLEDGE DISCLOSURE. (PART B IS INVALID UNLESS PART A HAS BEEN COMPLETED.)</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'end'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '15px'
                        }}>I/We,&nbsp;&nbsp;</div>
                        <div style={{
                            width: '46%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Print Purchaser's Name)
                            </div>
                        </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '15px',
                        }}>&nbsp;&nbsp;appoint&nbsp;&nbsp;</div>
                        <div style={{
                            width: '46%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Print Name of Dealership/Business)
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'end'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            paddingBottom: '15px'
                        }}>as of&nbsp;&nbsp;</div>
                        <div style={{
                            width: '27%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Date)
                            </div>
                        </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '13px',
                            paddingBottom: '15px',
                        }}>&nbsp;&nbsp; as my/our attorney-in-fact for the purpose of and with full authority to apply for title and/or registration, t o file a lien and</div>
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '13px',
                    }}>to sign the mileage disclosure on the title for the vehicle described above, only if the disclosure is exactly as the disclos ure completed below.</div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '13px',
                        margin: '3px 0'
                    }}><strong>WARNING:</strong> Federal law and State law require that you state the mileage in connection with transfer of ownership. Providing a false stat ement may result in fines or imprisonment.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                        }}>I/WE STATE THAT THIS</div>
                        <div style={{
                            width: '12px',
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0 5px 2px'
                        }}></div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                        }}>5DIGIT OR</div>
                        <div style={{
                            width: '12px',
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0 5px 2px'
                        }}></div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            marginRight: '12px'
                        }}>6 DIGIT ODOMETER NOW READS,</div>
                        
                        {digits.map((digit, index) => (
                            <React.Fragment key={index}>
                                <div key={index} style={{
                                    width: '12px',
                                    minWidth: '12px',
                                    height: '12px',
                                    border: 'solid 1px #000',
                                    margin: '0 2px 2px',
                                    fontSize: '10px',
                                    textAlign: 'center',
                                    lineHeight: '11px'
                                }}>
                                    {digit}
                                </div>
                                {index === 2 && ','}
                            </React.Fragment>
                        ))}
                        <div style={{
                            minWidth: '12px',
                            height: '12px',
                            border: 'solid 1px #000',
                            margin: '0px 0px 3px 10px',
                            fontFamily: 'Times New Roman',
                            fontSize: '8px',
                            padding: '0 1px'
                        }}>XX</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '8px',
                            marginRight: '12px',
                            marginLeft: '5px'
                        }}>(NO TENTHS) MILES,</div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                        }}>DATE READ</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{day[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{day[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            marginBottom: '-5px'
                        }}>/</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{month[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{month[1]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            marginBottom: '-5px'
                        }}>/</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{year[0]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            borderBottom: 'solid 1px #000',
                            minWidth: '11px',
                            margin: '0 1px',
                            textAlign: 'center'
                        }}>{year[1]}</div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                        }}>, AND I/WE HEREBY CERTIFY THAT TO THE BEST OF MY/OUR Knowledge the Odometer Reading:</div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '10px 0'
                        }}
                    >
                        <div style={{
                            width: '33.33%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>1. REFLECTS ACTUAL MILAGE</div>
                        </div>
                        <div style={{
                            width: '33.33%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>2. IS IN EXCESS OF ITS MECHANICAL LIMITS.</div>
                        </div>
                        <div style={{
                            width: '33.33%',
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'start'
                        }}>
                            <div style={{
                                width: '12px',
                                minWidth: '12px',
                                height: '12px',
                                border: 'solid 1px #000',
                                margin: '0px 3px 2px'
                            }}></div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                fontWeight: 'bold'
                            }}>3. IS NOT THE ACTUAL MILEAGE <br />
                                WARNING ODOMETER DISCREPANCY</div>
                        </div>
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '9px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>UNDER PENALTY OF PERJURY, I DECLARE THAT I HAVE READ THE FOREGOING DOCUMENT AND THAT THE FACTS STATED IN IT ARE TRUE.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '0 0',
                            flexWrap: 'wrap'
                        }}
                    >
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Seller's Signature
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Seller's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '71%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Business Address
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '75%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '25%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '85%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    State
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Zip
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Purchaser's Signature
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Purchaser's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '67%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Co Purchaser's Signature
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '65%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Co Purchaser's Printed Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '62%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Purchaser's Name
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '72%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Street Address
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '75%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '23.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '85%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    State
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Zip
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    {/* Part C */}

                    {/* Part B */}
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        borderTop: 'solid 1px #000',
                        paddingTop: '2px'
                    }}>PART C. CERTIFICATION BY ATTORNEY IN FACT (Person completing Part C must be the same person transferring information and signing the title.)</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '0'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                            textAlign: 'center',
                            marginTop: '3px'
                        }}>
                            I, &nbsp;
                        </div>
                        <div style={{
                            width: '50%'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                            }}>&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '9px',
                                textAlign: 'center'
                            }}>
                                (Print Name of Person exercising above power(s) of attorney
                            </div>
                        </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                            textAlign: 'left',
                            marginTop: '3px'
                        }}>
                            , &nbsp; hereby certify that the mileage I have disclosed on the title document is
                        </div>
                    </div>
                    <div
                        style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '10px',
                            textAlign: 'left',
                            marginTop: '3px'
                        }}>consistent with that provided to me in the above power(s) of attorney. Further, upon examination of the title and any reassignment documents for the vehicle described above, the mileage disclosure I have made on the title pursuant to the power of attorney is the same or greater than that previously stated on the title reassigned documents. This certificate is not intended to create, nor does it create any new or additional liability under Federal or State law</div>
                    <div style={{
                        fontFamily: 'Times New Roman',
                        fontSize: '9px',
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }}>UNDER PENALTY OF PERJURY, I DECLARE THAT I HAVE READ THE FOREGOING DOCUMENT AND THAT THE FACTS STATED IN IT ARE TRUE.</div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '0 0',
                            flexWrap: 'wrap'
                        }}
                    >
                        <div style={{
                            width: '30%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                textAlign: 'center',
                                marginTop: '3px'
                            }}>Signature&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                                width: '80%'
                            }}>&nbsp;</div>
                        </div>
                        <div style={{
                            width: '30%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                textAlign: 'center',
                                marginTop: '3px'
                            }}>Date&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                                width: '90%'
                            }}>&nbsp;</div>
                        </div>
                        <div style={{
                            width: '40%',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '10px',
                                textAlign: 'center',
                                marginTop: '3px'
                            }}>Printed Name&nbsp;</div>
                            <div style={{
                                fontFamily: 'Times New Roman',
                                fontSize: '11px',
                                borderBottom: 'solid 1px #000',
                                width: '75%'
                            }}>&nbsp;</div>
                        </div>
                        <div style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Street Address
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '76%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '24.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '85%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    State
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '70%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                        <div style={{
                            width: '12.5%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                margin: '3px 0'
                            }}>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '10px',
                                    textAlign: 'left',
                                    marginTop: '3px'
                                }}>
                                    Zip
                                </div>
                                <div style={{
                                    fontFamily: 'Times New Roman',
                                    fontSize: '11px',
                                    borderBottom: 'solid 1px #000',
                                    width: '90%'
                                }}>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'start',
                            margin: '0',
                            borderBottom: 'solid 1px #000',
                            justifyContent: 'space-around'
                        }}
                    >
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            paddingTop: '2px'
                        }}>ORIGINAL:DMS Copy (with Title) </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            paddingTop: '2px'
                        }}>GOLD COPY:Dealer/Business </div>
                        <div style={{
                            fontFamily: 'Times New Roman',
                            fontSize: '11px',
                            fontWeight: 'bold',
                            paddingTop: '2px'
                        }}>YELLOW COPY:Part A Seller</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PdfDownloader;
